'use strict'

import { Enum } from '@/app/model/base/enum'

export const values = {
  IN_PROCESS: 10,
  SUCCESS: 40
}

class StatusTypes extends Enum {

}

export default StatusTypes.initEnum(values)
